import qs from 'query-string';
import { useEffect, useState } from 'react';
import { generateUuid } from '../../_util/utils';
function customEvent(key, value) {
  var event = new Event('globalDrawerConfig');
  event.key = key;
  event.newValue = value;
  window.dispatchEvent(event);
}
const initInfo = () => {
  if (typeof window !== "undefined") {
    window._ZEND_globalDrawer = {
      config: [],
      getTabs: getTabs,
      setTabs: setTabs,
      initTab: initTab,
      addTab: addTab,
      setTab: setTab,
      removeTab: removeTab,
      removeTabs: removeTabs,
      getTabInfoOfUrl: getTabInfoOfUrl
    };
  }
};
export const getTabInfoOfUrl = () => {
  return qs.parse(location.hash);
};
export const getTabs = () => {
  var _window$_ZEND_globalD;
  return [...(((_window$_ZEND_globalD = window._ZEND_globalDrawer) === null || _window$_ZEND_globalD === void 0 ? void 0 : _window$_ZEND_globalD.config) || [])];
};
const setTabs = tabs => {
  window._ZEND_globalDrawer.config = tabs;
};
const initTab = tab => {
  setTabs([{
    ...tab,
    id: tab.id || generateUuid(),
    active: true
  }]);
  customEvent('initTab', undefined);
};
const addTab = tab => {
  const oldTabs = getTabs();
  let newTabs;
  // let flagIndex: number | undefined = undefined;
  if (oldTabs.some(item => item.type === tab.type)) {
    newTabs = oldTabs.map((item, index) => {
      if (item.type === tab.type) {
        // flagIndex = index;
        return {
          ...tab,
          id: tab.id || generateUuid(),
          active: true
        };
      } else {
        return {
          ...item,
          active: false
        };
      }
    });
    // if (flagIndex !== undefined) {
    //   newTabs = newTabs.filter((item, index) =>
    //     flagIndex ? index <= flagIndex : true
    //   );
    // }
  } else {
    newTabs = [...oldTabs.map(item => ({
      ...item,
      active: false
    })), {
      ...tab,
      id: tab.id || generateUuid(),
      active: true
    }];
  }
  setTabs(newTabs);
  customEvent('addTab', undefined);
};
const setTab = (id, config) => {
  const tabs = getTabs().map(item => item.id === id ? {
    ...item,
    ...config
  } : item);
  setTabs(tabs);
  customEvent('setTab', undefined);
};
export const getActiveId = () => {
  const oldTabs = getTabs();
  const activeTab = oldTabs.find(item => item.active);
  return activeTab === null || activeTab === void 0 ? void 0 : activeTab.id;
};
export const setActive = id => {
  const oldTabs = getTabs();
  let newTabs;
  newTabs = oldTabs.map((item, index) => {
    if (item.id === id) {
      return {
        ...item,
        active: true
      };
    } else {
      return {
        ...item,
        active: false
      };
    }
  });
  setTabs(newTabs);
  customEvent('setActive', undefined);
};
export const removeTab = id => {
  setTabs(getTabs().filter(tab => {
    if (tab.id === id) {
      var _tab$onClose;
      (_tab$onClose = tab.onClose) === null || _tab$onClose === void 0 || _tab$onClose.call(tab);
      return false;
    }
    return true;
  }));
  customEvent('removeTab', undefined);
};
export const removeTabs = () => {
  const tabs = getTabs();
  tabs.forEach(tab => {
    var _tab$onClose2;
    (_tab$onClose2 = tab.onClose) === null || _tab$onClose2 === void 0 || _tab$onClose2.call(tab);
  });
  setTabs([]);
  customEvent('removeTabs', undefined);
};
const addEventListener = eventFn => {
  //当前tab页有效
  window.addEventListener('globalDrawerConfig', function (e) {
    window.setTimeout(() => {
      eventFn(getTabs(), e);
    });
  });
};
export const useAddTabsEventListener = () => {
  const [tabs, setTabs] = useState([]);
  useEffect(() => {
    initInfo();
    addEventListener((newTabs, e) => {
      if (newTabs !== tabs) {
        setTabs(newTabs);
      }
    });
  }, []);
  return tabs;
};
export function useGlobalDrawer() {
  return window._ZEND_globalDrawer;
}